import type { TalkPreferences } from "./types";
import { talkBrand } from "./brand";

const STORAGE_KEY = `${talkBrand.storagePrefix}:talk-preferences`;
const PREFERENCES_VERSION = 2;

export const defaultPreferences: TalkPreferences = {
  cameraDeviceId: "",
  microphoneDeviceId: "",
  speakerDeviceId: "",
  cameraEnabled: true,
  microphoneEnabled: true,
  mirrorPreview: false,
  reducedData: false,
  reducedMotion: false,
  defaultLayout: "tiled",
};

function normalizedLayout(value: unknown): TalkPreferences["defaultLayout"] {
  if (value === "speaker" || value === "presentation" || value === "tiled") return value;
  // Migrate the previous equal-grid preference into the new dynamic tiled layout.
  if (value === "gallery") return "tiled";
  return defaultPreferences.defaultLayout;
}

export function loadPreferences(): TalkPreferences {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (!stored) return defaultPreferences;
    const parsed = JSON.parse(stored) as Partial<TalkPreferences> & { defaultLayout?: unknown; preferencesVersion?: unknown; haramMode?: unknown };
    const storedLayout = parsed.defaultLayout;
    const preferencesVersion = parsed.preferencesVersion;
    const storedPreferences = { ...parsed };
    delete storedPreferences.defaultLayout;
    delete storedPreferences.preferencesVersion;
    delete storedPreferences.haramMode;
    const mirrorPreview = preferencesVersion === PREFERENCES_VERSION && typeof parsed.mirrorPreview === "boolean"
      ? parsed.mirrorPreview
      : defaultPreferences.mirrorPreview;
    return { ...defaultPreferences, ...storedPreferences, mirrorPreview, defaultLayout: normalizedLayout(storedLayout) };
  } catch {
    return defaultPreferences;
  }
}

export function savePreferences(preferences: TalkPreferences): void {
  localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...preferences, preferencesVersion: PREFERENCES_VERSION }));
  document.documentElement.dataset.reduceMotion = String(preferences.reducedMotion);
}
